// extracted by mini-css-extract-plugin
module.exports = {"sidePanel":"_1P0iUNyb","sidePanelIconContainer":"_3v0NH3O6","text":"_3LbINim3","selected":"_1tDzjwZe","sidePanelOption":"_1dL9EcOe","sidePanelOptionSelected":"_2pfJDq8R"};